
import React, { useEffect, useState } from 'react'
import { compose } from 'widgets-shared/core'
import Typography from '@mui/material/Typography'
import usePreviousValue from 'smartstream-widgets/hooks/usePreviousValue/usePreviousValue'

import { withStyles, createStyles } from '@mui/styles'

export type Props = {
  animationDuration: number,
  animationType: "slideUp" | "fadeIn",
  align: "inherit" | "left" | "center" | "right" | "justify",
  className: string,
  classes: {
    [K in string]: string
  },
  stat: number
}

const styles = () =>  createStyles({
  statAnimation: (props: Props) => ({
    animationTimingFunction: 'ease-in',
    animationDuration: `${props.animationDuration || 400}ms`
  }),
  slideUp: {
    animationName: '$slideUp'
  },
  fadeIn: {
    animationName: '$fadeIn'
  },
  '@keyframes slideUp': {
    from: {
      opacity: 0,
      transform: 'translate(0px, 20px)'
    },
    to: {
      opacity: 1,
      transform: 'translate(0px, 0px)'
    }
  },
  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 }
  }
})

export function StatCounter (props: Props) {
  const {
    className = '',
    animationDuration = 400,
    animationType,
    align,
    classes,
    stat
  } = props

  const [statAnimate, setStatAnimate] = useState(false)
  const prevStat = usePreviousValue(stat)
  const statClass = statAnimate ? `${classes.statAnimation} ${classes[animationType]}` : ''

  useEffect(() => {
    let timeoutId

    if (prevStat < stat) {
      setStatAnimate(true)

      timeoutId = setTimeout(() => {
        setStatAnimate(false)
      }, animationDuration)
    }

    return () => {
      clearTimeout(timeoutId)
    }
  }, [stat])

  return (
    <Typography data-testid='stat-counter' className={`${className} ${statClass}`} align={align || 'left'}>{stat}</Typography>
  )
}

export default compose(
  withStyles(styles),
)(StatCounter)
